import React, { useState } from "react";
import { RECON_LISTINGS, FINANCING_OPTIONS } from "./data.js";

const REDFLAG_OPTIONS = [
  { id: true, label: "Red Flag" },
  { id: false, label: "Looks Good" },
];

export default function ReconStage({ onComplete }) {
  const [index, setIndex] = useState(0);
  const [tags, setTags] = useState({});
  const [correctCount, setCorrectCount] = useState(0);
  const [flash, setFlash] = useState(null);

  const current = RECON_LISTINGS[index];
  const done = index >= RECON_LISTINGS.length;

  const chooseTag = (field, value) => {
    if (!current) return;
    const existing = tags[current.id] || {};
    const updated = { ...existing, [field]: value };
    setTags((prev) => ({ ...prev, [current.id]: updated }));

    if (updated.financing && typeof updated.redFlag === "boolean") {
      const bothCorrect = updated.financing === current.correctFinancing && updated.redFlag === current.correctRedFlag;
      if (bothCorrect) setCorrectCount((c) => c + 1);
      setFlash(bothCorrect ? "correct" : "off");
      setTimeout(() => {
        setFlash(null);
        setIndex((i) => i + 1);
      }, 700);
    }
  };

  if (done) {
    return (
      <div className="animate-popIn text-center">
        <p className="label-pixel mb-2 text-lime">Recon Complete</p>
        <h2 className="pixel-heading mb-4 text-base text-mist">Market Scouted</h2>

        <div className="mx-auto mb-6 max-w-sm space-y-2 border-2 border-black bg-ink p-4 text-left text-sm">
          <div className="flex justify-between">
            <span className="text-mist/60">Classified Correctly</span>
            <span className="text-lime">
              {correctCount}/{RECON_LISTINGS.length}
            </span>
          </div>
        </div>

        <p className="mx-auto mb-6 max-w-sm text-xs text-mist/60">
          Every deal type has its own rules for financing and red flags. Land, rentals, and house
          hacks each play a different game — time to pick yours.
        </p>

        <button onClick={() => onComplete({ correctCount })} className="btn-magenta">
          CHOOSE YOUR PATH ▶
        </button>
      </div>
    );
  }

  return (
    <div>
      <div className="mb-4 flex items-center justify-between font-display text-[9px] text-mist/60">
        <span>RECON</span>
        <span>
          {index}/{RECON_LISTINGS.length} REVIEWED
        </span>
      </div>

      <p className="mb-5 text-xs text-mist/60">
        Six real listings. Tag how each would likely be financed, and whether it's a deal worth
        walking away from.
      </p>

      <div
        key={current.id}
        className={`mb-5 border-2 border-black bg-ink p-5 transition-colors ${
          flash === "correct" ? "border-lime shadow-glow-cyan" : flash === "off" ? "border-danger" : ""
        }`}
      >
        <p className="pixel-heading mb-2 text-sm text-mist">{current.title}</p>
        <p className="text-xs leading-relaxed text-mist/70">{current.description}</p>
        {flash && <p className="mt-3 text-[11px] text-mist/50">{current.note}</p>}
      </div>

      <div className="mb-4">
        <p className="label-pixel mb-2 text-mist/60">Financing Path</p>
        <div className="grid grid-cols-3 gap-2">
          {FINANCING_OPTIONS.map((opt) => {
            const selected = tags[current.id]?.financing === opt.id;
            return (
              <button
                key={opt.id}
                onClick={() => chooseTag("financing", opt.id)}
                className={`border-2 px-2 py-2 font-display text-[8px] uppercase transition-colors ${
                  selected ? "border-cyan bg-cyan text-ink" : "border-mist/30 text-mist/70 hover:border-cyan"
                }`}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>

      <div>
        <p className="label-pixel mb-2 text-mist/60">Deal Quality</p>
        <div className="grid grid-cols-2 gap-2">
          {REDFLAG_OPTIONS.map((opt) => {
            const selected = tags[current.id]?.redFlag === opt.id;
            return (
              <button
                key={String(opt.id)}
                onClick={() => chooseTag("redFlag", opt.id)}
                className={`border-2 px-3 py-2 font-display text-[9px] uppercase transition-colors ${
                  selected ? "border-magenta bg-magenta text-ink" : "border-mist/30 text-mist/70 hover:border-magenta"
                }`}
              >
                {opt.label}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}
